import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// components
import { Image, Input, Button } from 'semantic-ui-react';
// redux
import { login } from 'app/redux/actions/auth.action';
// img
import logo from 'assets/images/HAI-logo-SALVUS.png';
// styles
import './Login.scss';

class Login extends Component {
  state = { email: '', password: '' };

  onChange = (e, { name, value }) => this.setState({ [name]: value });

  onKeyDown = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      this.onSubmit();
    }
  };

  onSubmit = () => this.props.dispatch(login(this.state.email, this.state.password));

  render() {
    const { loading, error, isAuthenticated } = this.props.auth;
    if (isAuthenticated) return <Redirect to={{ pathname: '/' }} />;

    return (
      <div id='page-login'>
        <div id='backdrop-cylinder' />
        <div id='form'>
          <div id='form-wrapper'>
            <Image src={logo} alt='logo' className='img-logo' />
            {error && (
              <div className='txt-error'>
                Os dados informados estão incorretos. Tente novamente.
              </div>
            )}
            <Input
              placeholder='login'
              name='email'
              className='input-login'
              type='email'
              onChange={this.onChange}
              onKeyDown={this.onKeyDown}
            />
            <Input
              placeholder='senha'
              name='password'
              className='input-password'
              type='password'
              onChange={this.onChange}
              onKeyDown={this.onKeyDown}
            />
            <Button
              id='btn-submit'
              content='Entrar'
              className='btn-login'
              type='submit'
              loading={loading}
              onClick={this.onSubmit}
            />
          </div>
        </div>
      </div>
    );
  }
}

Login.propTypes = {
  auth: PropTypes.object,
  dispatch: PropTypes.func
};

const mapStateToProps = state => ({
  auth: state.auth
});
export default connect(mapStateToProps)(Login);
